import React from 'react';
import { ImageSlide } from '../styles/staticImageSlide.style';
import CtaLinkRender from '../../../utils/linkRenderer';
import { generateImageUrl } from '../../../utils/webp';

/**
 * Returns a video if it's a local file
 * @param {string} localFileUrl local file
 * @param {object} backgroundImage incoming background image
 * @param {boolean} hideControls hide playback controls
 * @param {number} width width of image to be fetched
 * @returns {XML} A video or image element
 */
const getMediaObject = (localFileUrl, backgroundImage, hideControls, width) => {
  let outDiv = <div />;
  if (localFileUrl && (backgroundImage && backgroundImage.file)) {
    outDiv = (
      <video
        className="video"
        controls={!hideControls}
        playsInline
        autoPlay
        muted
        loop
        poster={backgroundImage.file.url}
      >
        <source src={`/videos/${localFileUrl}`} type="video/mp4" />
      </video>
    );
  } else if (!localFileUrl && (backgroundImage && backgroundImage.file)) {
    let src = backgroundImage.file.url;
    if (width) {
      src = generateImageUrl(src, width);
    }
    outDiv = <div className="slide-bg" style={{ backgroundImage: `url(${src})` }} />;
  } else if (localFileUrl && !(backgroundImage && backgroundImage.file)) {
    outDiv = (
      <video className="video" controls={!hideControls} playsInline autoPlay muted loop>
        <source src={`/videos/${localFileUrl}`} type="video/mp4" />
      </video>
    );
  }

  return outDiv;
};

/**
 * Static Image Slide
 * @param {object} props Incoming Props
 * @returns {XML} A Static Image slide
 */
class StaticImageSlide extends React.Component {
  /**
   * Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.ref = this.ref.bind(this);
    this.state = {
      width: 4000,
    };
  }

  /**
   * Get rect
   * @param {object} element DOM reference
   */
  ref(element) {
    if (element && element.getBoundingClientRect()) {
      this.setState({ width: element.getBoundingClientRect().width });
    }
  }

  /**
   * Renders an iframe with the video
   * @returns {XML} A video component
   */
  render() {
    const {
      localFileUrl,
      ctaUrl,
      backgroundImage,
      hideControls,
    } = this.props;
    const { width } = this.state;
    return (
      <div ref={this.ref}>
        <ImageSlide>
          {ctaUrl ? (
            <CtaLinkRender ctaLink={ctaUrl}>
              {getMediaObject(localFileUrl, backgroundImage, hideControls, width)}
            </CtaLinkRender>
          ) : (
            getMediaObject(localFileUrl, backgroundImage, hideControls, width)
          )}
        </ImageSlide>
      </div>
    );
  }
}

export default StaticImageSlide;



// WEBPACK FOOTER //
// ./src/components/hero-carousel/components/staticImageSlide.js